export var TOOLTIP_CLASS_NAMES = {
    appear: "rmd-tooltip--enter",
    appearActive: "rmd-tooltip--visible",
    enter: "rmd-tooltip--enter",
    enterActive: "rmd-tooltip--visible",
    enterDone: "rmd-tooltip--visible",
    exit: "rmd-tooltip--visible rmd-tooltip--exit",
    exitActive: "rmd-tooltip--exit-active",
};
export var TOOLTIP_TRANSITION_TIMEOUT = {
    enter: 200,
    exit: 150,
};
export var DEFAULT_DELAY = 1000;
export var DEFAULT_THRESHOLD = 0.75;
//# sourceMappingURL=constants.js.map